/*
Monotype Foundry Platform API
Version 1.0.0

Definition: ContractRequest

Properties:
  address1: string (required)
  address2: string
  city: string (required)
  contractText: string
  country: string (required)
  createdAt: string
  email: string (required)
  emailConsent: string
  foundryId: string (required)
  foundryOwnerName: string (required)
  hostName: string
  id: string
  ipAddress: string
  partnerId: string
  phone: string (required)
  pimContractId: string
  signedDate: string
  signerName: string (required)
  signerTitle: string (required)
  state: string
  status: string
  title: string
  updatedAt: string
  userId: string
  zipCode: string (required), maxLength: 10
*/

var ContractRequest = (function () {
  function validateContractRequest (arg) {
    // Validate address1
    if (!arg.address1) {
      throw new Error('ContractRequest.address1: Missing property')
    }
    if (arg.address1 && !(typeof arg.address1 === 'string')) {
      throw new Error('ContractRequest.address1: Wrong type: Got \'' + (typeof arg.address1) + '\', but expected: \'string\'')
    }
    // Validate address2
    if (arg.address2 && !(typeof arg.address2 === 'string')) {
      throw new Error('ContractRequest.address2: Wrong type: Got \'' + (typeof arg.address2) + '\', but expected: \'string\'')
    }
    // Validate city
    if (!arg.city) {
      throw new Error('ContractRequest.city: Missing property')
    }
    if (arg.city && !(typeof arg.city === 'string')) {
      throw new Error('ContractRequest.city: Wrong type: Got \'' + (typeof arg.city) + '\', but expected: \'string\'')
    }
    // Validate country
    if (!arg.country) {
      throw new Error('ContractRequest.country: Missing property')
    }
    if (arg.country && !(typeof arg.country === 'string')) {
      throw new Error('ContractRequest.country: Wrong type: Got \'' + (typeof arg.country) + '\', but expected: \'string\'')
    }
    // Validate email
    if (!arg.email) {
      throw new Error('ContractRequest.email: Missing property')
    }
    if (arg.email && !(typeof arg.email === 'string')) {
      throw new Error('ContractRequest.email: Wrong type: Got \'' + (typeof arg.email) + '\', but expected: \'string\'')
    }
    // Validate emailConsent
    if (arg.emailConsent && !(typeof arg.emailConsent === 'string')) {
      throw new Error('ContractRequest.emailConsent: Wrong type: Got \'' + (typeof arg.emailConsent) + '\', but expected: \'string\'')
    }
    // Validate foundryId
    if (!arg.foundryId) {
      throw new Error('ContractRequest.foundryId: Missing property')
    }
    if (arg.foundryId && !(typeof arg.foundryId === 'string')) {
      throw new Error('ContractRequest.foundryId: Wrong type: Got \'' + (typeof arg.foundryId) + '\', but expected: \'string\'')
    }
    // Validate foundryOwnerName
    if (!arg.foundryOwnerName) {
      throw new Error('ContractRequest.foundryOwnerName: Missing property')
    }
    if (arg.foundryOwnerName && !(typeof arg.foundryOwnerName === 'string')) {
      throw new Error('ContractRequest.foundryOwnerName: Wrong type: Got \'' + (typeof arg.foundryOwnerName) + '\', but expected: \'string\'')
    }
    // Validate phone
    if (!arg.phone) {
      throw new Error('ContractRequest.phone: Missing property')
    }
    if (arg.phone && !(typeof arg.phone === 'string')) {
      throw new Error('ContractRequest.phone: Wrong type: Got \'' + (typeof arg.phone) + '\', but expected: \'string\'')
    }
    // Validate signerName
    if (!arg.signerName) {
      throw new Error('ContractRequest.signerName: Missing property')
    }
    if (arg.signerName && !(typeof arg.signerName === 'string')) {
      throw new Error('ContractRequest.signerName: Wrong type: Got \'' + (typeof arg.signerName) + '\', but expected: \'string\'')
    }
    // Validate signerTitle
    if (!arg.signerTitle) {
      throw new Error('ContractRequest.signerTitle: Missing property')
    }
    if (arg.signerTitle && !(typeof arg.signerTitle === 'string')) {
      throw new Error('ContractRequest.signerTitle: Wrong type: Got \'' + (typeof arg.signerTitle) + '\', but expected: \'string\'')
    }
    // Validate state
    if (arg.state && !(typeof arg.state === 'string')) {
      throw new Error('ContractRequest.state: Wrong type: Got \'' + (typeof arg.state) + '\', but expected: \'string\'')
    }
    // Validate status
    if (arg.status && !(typeof arg.status === 'string')) {
      throw new Error('ContractRequest.status: Wrong type: Got \'' + (typeof arg.status) + '\', but expected: \'string\'')
    }
    // Validate title
    if (arg.title && !(typeof arg.title === 'string')) {
      throw new Error('ContractRequest.title: Wrong type: Got \'' + (typeof arg.title) + '\', but expected: \'string\'')
    }
    // Validate zipCode
    if (!arg.zipCode) {
      throw new Error('ContractRequest.zipCode: Missing property')
    }
    if (arg.zipCode && !(typeof arg.zipCode === 'string')) {
      throw new Error('ContractRequest.zipCode: Wrong type: Got \'' + (typeof arg.zipCode) + '\', but expected: \'string\'')
    }
    if (arg.zipCode && !(arg.zipCode.length <= 10)) {
      throw new Error('ContractRequest.zipCode: Maximum length 10, but got: ' + arg.zipCode.length)
    }
  }
  function buildContractRequest (arg) {
    var ContractRequest = arg
    // Complete address1
    // Expected Type: string
    ContractRequest.address1 = ContractRequest.address1 || ''
    // Complete address2
    // Expected Type: string
    ContractRequest.address2 = ContractRequest.address2 || ''
    // Complete city
    // Expected Type: string
    ContractRequest.city = ContractRequest.city || ''
    // Complete country
    // Expected Type: string
    ContractRequest.country = ContractRequest.country || ''
    // Complete email
    // Expected Type: string
    ContractRequest.email = ContractRequest.email || ''
    // Complete emailConsent
    // Expected Type: string
    ContractRequest.emailConsent = ContractRequest.emailConsent || ''
    // Complete foundryId
    // Expected Type: string
    ContractRequest.foundryId = ContractRequest.foundryId || ''
    // Complete foundryOwnerName
    // Expected Type: string
    ContractRequest.foundryOwnerName = ContractRequest.foundryOwnerName || ''
    // Complete phone
    // Expected Type: string
    ContractRequest.phone = ContractRequest.phone || ''
    // Complete signerName
    // Expected Type: string
    ContractRequest.signerName = ContractRequest.signerName || ''
    // Complete signerTitle
    // Expected Type: string
    ContractRequest.signerTitle = ContractRequest.signerTitle || ''
    // Complete state
    // Expected Type: string
    ContractRequest.state = ContractRequest.state || ''
    // Complete status
    // Expected Type: string
    ContractRequest.status = ContractRequest.status || ''
    // Complete title
    // Expected Type: string
    ContractRequest.title = ContractRequest.title || ''
    // Complete zipCode
    // Expected Type: string
    ContractRequest.zipCode = ContractRequest.zipCode || ''
    return ContractRequest
  }
  return {
    validate: validateContractRequest,
    build: buildContractRequest
  }
})()

module.exports = ContractRequest
